/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_BOOSTTIME = 23;

Mission.REGISTRATIONS.set(Mission.TYPE_BOOSTTIME, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.BOOSTTIME_MISSION,
    name: "BoostTime",
    duration: "1 day",
    semaphore: Mission.SEMAPHORE_SECONDARY,
    bundle: "boosttime",
    sideBarJson: bundles.sidebar.jsons.boosttime_icon_json,
    view: BoostTimeMissionWindow,
    startWindow: BoostTimeMissionWindow,
    finishWindow: BoostTimeMissionWindow
}));
